import {
  SnippetElement,
  defineElement,
  on
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/snippets/shop-customer-logos-elm/shop-customer-logos-elm.ts
var ShopCustomerLogosElm = class extends SnippetElement {
  connectedCallback() {
    return __async(this, null, function* () {
      console.log("init snippet ShopCustomerLogosElm");
    });
  }
  handleClick() {
    console.log("clicked");
  }
};
__decorateClass([
  on("click")
], ShopCustomerLogosElm.prototype, "handleClick", 1);
ShopCustomerLogosElm = __decorateClass([
  defineElement("shop-customer-logos-elm")
], ShopCustomerLogosElm);
export {
  ShopCustomerLogosElm
};
